import React from "react";
import { ToasterProps } from "./types";
import * as styled from "./styles";
import SuccessIcon from "@ui/assets/icons/check-icon.svg";
import InfoIcon from "@mui/icons-material/Info";
import ErrorAlertIcon from "@ui/assets/icons/error-alert-icon.svg";
import ZigTypography from "../ZigTypography";
import { useTheme } from "@mui/material";

const Toaster = ({ variant = "error", size = "large", caption = "", id }: ToasterProps) => {
  const { palette } = useTheme();
  return (
    <styled.ToastContainer variant={variant} size={size} id={id}>
      <styled.IconContainer size={size}>
        {variant === "error" && <ErrorAlertIcon color={palette.red} />}
        {variant === "success" && <SuccessIcon color={palette.green} />}
        {variant === "info" && <InfoIcon fill={palette.neutral600} />}
      </styled.IconContainer>

      <styled.Caption variant={variant}>
        <ZigTypography
          variant={size === "large" ? "body1" : "body2"}
          /* @ts-ignore */
          color={{ error: "red", success: "green" }[variant]}
          fontWeight="regular"
        >
          {caption}
        </ZigTypography>
      </styled.Caption>
    </styled.ToastContainer>
  );
};

export default Toaster;
